import { render, staticRenderFns } from "./IssueBadgeButton.vue?vue&type=template&id=596a5bfa&scoped=true"
import script from "./IssueBadgeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IssueBadgeButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IssueBadgeButton.vue?vue&type=style&index=0&id=596a5bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a5bfa",
  null
  
)

export default component.exports